import { PropertyDetails } from 'types/models/inventory/PropertyDetails';

export interface InspectionOptimizerOutput {
  id: string;
  propertyId: PropertyDetails['id'];
  modelId: string;
  featureStratification: string;
  utilityStatus: string;
  privateStatus: string;
  inspectionRecommended: 'Primary' | 'Alternate' | 'Utility Recommended';
}

export class InspectionOptimizerOutput {}
